import React from 'react';

const CORE_VALUES = [
  {
    title: "We're from here.",
    description: "Not 'Africa-focused' from a headquarters in Paris. Actually from here built in Douala, serving clients across Cameroon, and deeply familiar with what it means to run a business in this environment. That context shapes everything we build and every recommendation we make.",
    icon: (
      <div className="w-8 h-8 relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-1.5 h-1.5 rounded-full bg-[#212121] outline outline-[2.5px] outline-[#212121] outline-offset-[4px]"></div>
        </div>
      </div>
    ),
  },
  {
    title: "We hold ourselves to a high standard.",
    description: "Being local doesn't mean being basic. Our software is built with the same rigour you'd expect from companies operating at an international level. Our marketing strategies are grounded in real data and clear thinking. We don't do things halfway, and we don't work with clients who want us to.",
    icon: (
      <div className="w-8 h-8 relative flex items-center justify-center">
        <div className="w-[20px] h-[9px] bg-[#212121] absolute bottom-[6px]"></div>
        <div className="w-[28px] h-[20px] bg-[#212121] absolute top-[3px]"></div>
      </div>
    ),
  },
  {
    title: "We don't take every client.",
    description: "We're looking for partners who are as serious as we are. If you want something cheap, fast, and disposable, we aren't the right fit. We work with businesses that value quality and understand that real growth takes real work.",
    icon: (
      <div className="w-8 h-8 relative flex items-center justify-center">
        <div className="w-[12px] h-[7px] bg-[#212121] absolute top-[3px]"></div>
        <div className="w-[28px] h-[20px] bg-[#212121] absolute bottom-[3px]"></div>
      </div>
    ),
  },
  {
    title: "We are built for the long run.",
    description: "Our goal is not just the next project, but the next five years of your success. We structure our contracts, our code, and our communication for long-term reliability. We aren't looking for a quick win; we're looking for a legacy.",
    icon: (
      <div className="w-8 h-8 relative flex items-center justify-center">
        <div className="w-5 h-5 rounded-full border-[2px] border-[#212121] flex items-center justify-center">
          <div className="w-[2px] h-[7px] bg-[#212121] origin-bottom"></div>
        </div>
      </div>
    ),
  },
];

const WhoWeAre: React.FC = () => {
  return (
    <section className="bg-white py-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#F8FAFE] opacity-50 pointer-events-none"></div>

      <div className="layout-container max-w-[1360px] mx-auto px-5 relative z-10">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:sticky lg:top-24 max-w-[320px]">
            <h2 className="font-title text-[32px] md:text-[40px] font-medium leading-[1.1]">
              <span className="text-[#212121]">Our </span>
              <span className="text-[#919191]">Values</span>
            </h2>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12">
              {CORE_VALUES.map((value, index) => (
                <div key={index} className="flex flex-col gap-3 max-w-[360px]">
                  <div className="text-[#212121]">
                    {value.icon}
                  </div>
                  <h3 className="font-title text-[18px] md:text-[20px] font-medium leading-tight text-[#212121]">
                    {value.title}
                  </h3>
                  <p className="font-description text-[12px] md:text-[13px] font-light leading-[1.55] text-[#919191]">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
